import TableView from '../store/schema/TableView';
import { TableQueryType } from '../store/schema/TableQuery';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * @param tableView for which we want to get the context folder id
 * @param returnFolderScopeIfEnabled returns context folder id as the original folder Id if the flight is enabled
 * @return Returns folderId for the table view
 */
export default function getContextFolderIdForTable(
    tableView: TableView,
    returnFolderScopeIfEnabled?: boolean
): string {
    switch (tableView.tableQuery.type) {
        case TableQueryType.Folder:
            if (isFeatureEnabled('tri-triageFolderScope') && returnFolderScopeIfEnabled) {
                return tableView.tableQuery.folderId;
            }
            return tableView.serverFolderId;

        case TableQueryType.Search:
        case TableQueryType.Group:
        default:
            return null;
    }
}
